import { CSSProperties, useMemo } from 'react';

import Checkbox from '@components/Checkbox';
import { FlexibleDiv } from '@components/formStyles';

import { MonthItem } from '../interface';
import {
  YearMonthItem,
  YearMonthsItems,
  YearTabWrapper,
  SelectWholeTermItem,
} from '../styled';

interface Props {
  months: MonthItem[];
  handleMonthChange: (month: string, checked: boolean) => void;
  toggleAllMonths: (val: boolean) => void;
  yearMonthsItemsStyle?: CSSProperties;
}

const YearTab = ({
  months,
  handleMonthChange,
  toggleAllMonths,
  yearMonthsItemsStyle,
}: Props) => {
  const allMonthsSelected = useMemo(() => {
    return months.every((month) => month.checked);
  }, [months]);

  return (
    <YearTabWrapper>
      <YearMonthsItems style={yearMonthsItemsStyle}>
        {months?.map((currentMonth) => (
          <FlexibleDiv key={currentMonth.name}>
            <YearMonthItem>
              <Checkbox
                title={currentMonth.name}
                checked={currentMonth.checked}
                onChange={(val) => handleMonthChange(currentMonth.name, val)}
                mode='controlled'
              />
            </YearMonthItem>
          </FlexibleDiv>
        ))}
      </YearMonthsItems>
      <SelectWholeTermItem>
        <Checkbox
          title='Tüm Dönem'
          mode='controlled'
          checked={allMonthsSelected}
          onChange={(val) => toggleAllMonths(val)}
        />
      </SelectWholeTermItem>
    </YearTabWrapper>
  );
};

export default YearTab;
